import * as requests from "./requests"

const api = {
  requests
}

export default api
